import type * as Types from 'app/types/graphql';

import {
  ProductEdgeSelectFragmentDoc,
  ProductSelectFragmentDoc,
} from '../fragments/products.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ProductsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  before?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.ProductOrder>;
  where?: Types.InputMaybe<Types.ProductWhereInput>;
}>;

export type ProductsQueryResponse = {
  products?: Types.Maybe<{
    edges: Array<{
      node?: Types.Maybe<
        Pick<Types.Product, 'baseID' | 'title' | 'handle'> & {
          featuredImage?: Types.Maybe<Pick<Types.Media, 'src'>>;
        }
      >;
    }>;
  }>;
};

export const ProductsDocument = `
    query Products($after: Cursor, $before: Cursor, $first: Int, $last: Int, $orderBy: ProductOrder, $where: ProductWhereInput) {
  products(
    after: $after
    before: $before
    first: $first
    last: $last
    orderBy: $orderBy
    where: $where
  ) {
    edges {
      ...ProductEdgeSelect
    }
  }
}
    ${ProductEdgeSelectFragmentDoc}
${ProductSelectFragmentDoc}`;

export const useProductsQuery = <TData = ProductsQueryResponse, TError = unknown>(
  variables?: ProductsQueryVariables,
  options?: UseQueryOptions<ProductsQueryResponse, TError, TData>,
) => {
  return useQuery<ProductsQueryResponse, TError, TData>(
    variables === undefined ? ['Products'] : ['Products', variables],
    appFetcher<ProductsQueryResponse, ProductsQueryVariables>(ProductsDocument, variables),
    options,
  );
};

useProductsQuery.getKey = (variables?: ProductsQueryVariables) =>
  variables === undefined ? ['Products'] : ['Products', variables];
